module.exports = __webpack_public_path__ + "static/media/students-icon.1e191769.svg";